import { WidgetProps } from './models';

export const DEFAULT_WIDGET_PROPS: WidgetProps = {
  container: {
    name: '',
    props: {},
  },
  component: {
    name: '',
    props: {},
  },
};

export const CONTAINED_WIDGET_JSON_POINTERS = {
  CONTAINER: {
    NAME: 'spec.view[1][0]',
    PROPS: 'spec.view[1][1]',
  },
  COMPONENT: {
    NAME: 'spec.view[1][2][0][0]',
    PROPS: 'spec.view[1][2][0][1]',
  },
};

export const UNCONTAINED_WIDGET_JSON_POINTERS = {
  NAME: 'spec.view[0][0]',
  PROPS: 'spec.view[0][1]',
};
